import { directVatRateOptions } from './vatRates'

export const updNdsOptions = directVatRateOptions

export const updMeasureOptions = [
  { value: '796', label: 'Штука', symbol: 'шт' },
  { value: '166', label: 'Килограмм', symbol: 'кг' },
  { value: '006', label: 'Метр', symbol: 'м' },
  { value: '112', label: 'Литр', symbol: 'л' },
  { value: '-', label: 'Услуга' }
]

export function updMeasurePayload(row = {}) {
  const selection = row.measure_value
  const code = String(selection && typeof selection === 'object' ? (selection.value || '') : (selection || '')).trim()
  if (!code || code === '-') return { measure_value: '', measure_label: '' }
  const option = updMeasureOptions.find((item) => item.value === code)
  const selectedLabel = selection && typeof selection === 'object' ? selection.label : ''
  return {
    measure_value: code,
    measure_label: String(row.measure_label || (option && (option.symbol || option.label)) || selectedLabel || '').trim()
  }
}

export const updDirectionOptions = [
  { label: 'Входящий', value: 'in' },
  { label: 'Исходящий', value: 'out' },
  { label: 'Внутренний', value: 'internal' }
]

export function parseUpdAmount(value) {
  if (value === null || value === undefined || value === '') {
    return 0
  }
  if (typeof value === 'object' && value.value !== undefined) {
    return parseUpdAmount(value.value)
  }
  const normalized = String(value).replace(/\s/g, '').replace(',', '.')
  const parsed = Number.parseFloat(normalized)
  return Number.isFinite(parsed) ? parsed : 0
}

export function roundUpdMoney(value) {
  return Math.round((parseUpdAmount(value) + Number.EPSILON) * 100) / 100
}

export function calculateUpdRow(row, isService = false) {
  const price = parseUpdAmount(row.price)
  const count = isService ? 1 : parseUpdAmount(row.count)
  const nds = parseUpdAmount(row.nds)
  const aciz = parseUpdAmount(row.aciz)
  const costWithoutNds = roundUpdMoney(price * count)
  const taxableTotal = roundUpdMoney(costWithoutNds + aciz)
  const nalog = roundUpdMoney(taxableTotal * nds)
  return {
    ...row,
    cost_without_nds: costWithoutNds,
    nalog,
    summtotal: roundUpdMoney(taxableTotal + nalog)
  }
}

export function calculateUpdSummary(rows) {
  return rows.reduce((summary, row) => {
    summary.cost_without_nds = roundUpdMoney(summary.cost_without_nds + parseUpdAmount(row.cost_without_nds))
    summary.nalog = roundUpdMoney(summary.nalog + parseUpdAmount(row.nalog))
    summary.summtotal = roundUpdMoney(summary.summtotal + parseUpdAmount(row.summtotal))
    return summary
  }, { cost_without_nds: 0, nalog: 0, summtotal: 0 })
}

export function createEmptyUpdRow(id, uuid, defaults = {}) {
  return {
    code: '',
    id,
    uuid,
    name: '',
    kind_code: '',
    measure_value: updMeasureOptions[0],
    measure_label: '',
    count: '',
    price: '',
    cost_without_nds: 0,
    aciz: '',
    nds: updNdsOptions[0],
    nalog: 0,
    summtotal: 0,
    contrycode: '',
    countryname: '',
    doc: '',
    trace_unit_code: '',
    trace_unit_name: '',
    trace_quantity: '',
    trace_cost_without_nds: '',
    warehouse_id: defaults.warehouse_id || null,
    warehouse: defaults.warehouse || null,
    nomenclature_id: defaults.nomenclature_id || null,
    nomenclature: defaults.nomenclature || null
  }
}

export function normalizePartyIdentifier(value) {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value).replace(/\D/g, '')
}

export function buildInnKpp(inn, kpp) {
  return [normalizePartyIdentifier(inn), normalizePartyIdentifier(kpp)].filter(Boolean).join(' ')
}

export function counterpartySnapshot(counterparty = {}) {
  const id = counterparty.counterparty_id || counterparty.id
  if (!id) {
    return null
  }
  return {
    id,
    name: counterparty.name || counterparty.short_name || counterparty.full_name || '',
    short_name: counterparty.short_name || counterparty.name || '',
    full_name: counterparty.full_name || counterparty.name || '',
    inn: normalizePartyIdentifier(counterparty.inn),
    kpp: normalizePartyIdentifier(counterparty.kpp),
    ogrn: normalizePartyIdentifier(counterparty.ogrn),
    type: counterparty.type || counterparty.counterparty_type || 'unknown',
    status: counterparty.status || 'unknown',
    address: counterparty.address || counterparty.legal_address || counterparty.actual_address || '',
    legal_address: counterparty.legal_address || '',
    actual_address: counterparty.actual_address || '',
    is_active: counterparty.is_active !== false
  }
}

export function partyFromCounterpartyDirectory(item = {}) {
  const snapshot = counterpartySnapshot(item)
  return {
    counterparty_id: item.id || item.counterparty_id || null,
    counterparty_snapshot: snapshot,
    name: item.name || item.short_name || item.full_name || '',
    address: item.address || item.legal_address || item.actual_address || '',
    inn: normalizePartyIdentifier(item.inn),
    kpp: normalizePartyIdentifier(item.kpp),
    innKpp: buildInnKpp(item.inn, item.kpp)
  }
}

export function nomenclatureSnapshot(item = {}) {
  const id = item.id || item.primary || item.nomenclature_id
  if (!id) {
    return null
  }
  return {
    id,
    code: item.code || '',
    name: item.common_name || item.name || '',
    unit_code: item.unit_code || '',
    unit_name: item.unit_name || '',
    article: item.article || '',
    barcode: item.barcode || ''
  }
}

export function partyFromDaData(info = {}) {
  const source = info.data || info
  const name = typeof source.name === 'object' && source.name !== null ? source.name : {}
  const address = typeof source.address === 'object' && source.address !== null ? source.address : {}
  const flatName = typeof source.name === 'string' ? source.name : ''
  const flatAddress = typeof source.address === 'string' ? source.address : ''
  return {
    name: source.short_name || flatName || name.short_with_opf || name.full_with_opf || info.value || '',
    address: flatAddress || source.legal_address || address.unrestricted_value || address.value || '',
    inn: normalizePartyIdentifier(source.inn),
    kpp: normalizePartyIdentifier(source.kpp),
    innKpp: buildInnKpp(source.inn, source.kpp)
  }
}

export function partyFromOrganisationMetadata(meta = {}) {
  const fullData = meta.full_data || {}
  const name = fullData.name || {}
  const address = fullData.address || {}
  return {
    name: meta.display_name || meta.name || name.short_with_opf || name.full_with_opf || '',
    address: meta.adress || meta.address || address.unrestricted_value || address.value || '',
    innKpp: [meta.inn || fullData.inn, meta.kpp || fullData.kpp].filter(Boolean).join(' ')
  }
}

export function partiesForUpdDirection(direction, orgParty, counterparty) {
  if (direction === 'in') {
    return {
      seller: counterparty,
      customer: orgParty
    }
  }
  if (direction === 'internal') {
    return {
      seller: orgParty,
      customer: orgParty
    }
  }
  return {
    seller: orgParty,
    customer: counterparty
  }
}

export function buildUpdDocumentBody({ direction, seller, customer, rows, summary, documentDate, inOrgNumber, isService, status }) {
  const selectedCounterparty = [seller, customer].find((party) => party && (party.counterparty_id || party.counterparty_snapshot))
  const snapshot = selectedCounterparty
    ? (selectedCounterparty.counterparty_snapshot || counterpartySnapshot(selectedCounterparty))
    : null
  return {
    summary,
    is_service: isService,
    document_direction: direction,
    counterparty_id: selectedCounterparty ? (selectedCounterparty.counterparty_id || selectedCounterparty.id || null) : null,
    counterparty_snapshot: snapshot,
    cust: customer.name,
    cust_adr: customer.address,
    cust_inn: customer.innKpp,
    currency: 'Российский рубль, 643',
    goscon: null,
    seller: seller.name,
    seller_adr: seller.address,
    seller_inn: seller.innKpp,
    seller_sender: seller.name && seller.address ? `${seller.name}, ${seller.address}` : seller.name,
    seller_receiver: customer.name && customer.address ? `${customer.name}, ${customer.address}` : customer.name,
    seller_doc: null,
    seller_send_doc: null,
    advance_invoice_info: null,
    change_n: null,
    change_date: null,
    code: null,
    date: null,
    kind_code: null,
    status,
    rukvod: null,
    glavbuh: null,
    ip_name: null,
    ip_req: null,
    osn_rec_sent: null,
    transp: null,
    goods_sent: null,
    goods_sent_workplace: null,
    goods_sent_fio: null,
    date_sent: null,
    sent_info: null,
    hozvod_workplace: null,
    hozvod_fio: null,
    econom_name: null,
    date_rec: null,
    goods_rec_fio: null,
    goods_rec_workplace: null,
    rec_info: null,
    econom_rec_name: null,
    hozvod_rec_fio: null,
    hozvod_rec_workplace: null,
    table_rows: rows.map((row, index) => {
      const stockFields = isService
        ? {
          warehouse_id: null,
          warehouse: null,
          nomenclature_id: null,
          nomenclature: null
        }
        : {
          warehouse_id: row.warehouse_id || (row.warehouse && row.warehouse.id) || null,
          warehouse: row.warehouse || null,
          nomenclature_id: row.nomenclature_id || (row.nomenclature && row.nomenclature.id) || null,
          nomenclature: row.nomenclature || null
        }
      return {
        ...row,
        id: index + 1,
        ...updMeasurePayload(row),
        count: isService ? (row.count || 1) : row.count,
        trace_unit_code: row.trace_unit_code || '',
        trace_unit_name: row.trace_unit_name || '',
        trace_quantity: row.trace_quantity || '',
        trace_cost_without_nds: row.trace_cost_without_nds || '',
        ...stockFields
      }
    }),
    in_org_number: inOrgNumber,
    document_date: documentDate,
    document_type: 'upd',
    report_type: 'none'
  }
}

const UPD_BODY_DEFAULTS = Object.freeze({
  summary: { cost_without_nds: 0, nalog: 0, summtotal: 0 },
  is_service: false,
  document_direction: 'out',
  counterparty_id: null,
  counterparty_snapshot: null,
  cust: '',
  cust_adr: '',
  cust_inn: '',
  currency: 'Российский рубль, 643',
  goscon: '',
  seller: '',
  seller_adr: '',
  seller_inn: '',
  seller_sender: '',
  seller_receiver: '',
  seller_doc: '',
  seller_send_doc: '',
  payment_reference: '',
  advance_invoice_info: '',
  has_advance_offset: false,
  change_n: '',
  change_date: '',
  code: '',
  date: '',
  kind_code: '',
  status: 1,
  function: '',
  signatory_type: '',
  signatory: { fio: '', position: '' },
  signed_by_poa: false,
  rukvod: '',
  glavbuh: '',
  ip_name: '',
  ip_req: '',
  poa: '',
  osn_rec_sent: '',
  transp: '',
  goods_sent: '',
  goods_sent_workplace: '',
  goods_sent_fio: '',
  date_sent: '',
  sent_info: '',
  hozvod_workplace: '',
  hozvod_fio: '',
  econom_name: '',
  date_rec: '',
  goods_rec_fio: '',
  goods_rec_workplace: '',
  rec_info: '',
  econom_rec_name: '',
  hozvod_rec_fio: '',
  hozvod_rec_workplace: '',
  table_rows: [],
  in_org_number: '',
  document_date: '',
  document_type: 'upd',
  report_type: 'none'
})

function cloneUpdValue(value) {
  if (value === undefined) return undefined
  return JSON.parse(JSON.stringify(value))
}

function normalizeSelectOption(value, options, fallback) {
  if (value && typeof value === 'object') {
    const label = value.label || value.name || ''
    const matched = options.find((option) => label && String(option.label) === String(label))
      || options.find((option) => value.value !== undefined && String(option.value) === String(value.value))
    return matched || cloneUpdValue(value)
  }
  if (value !== null && value !== undefined && value !== '') {
    const matched = options.find((option) => String(option.value) === String(value) || String(option.label) === String(value))
    return matched || { label: String(value), value }
  }
  return cloneUpdValue(fallback)
}

export function normalizeUpdRow(row = {}, index = 0, uuidFactory = () => `upd-row-${index + 1}`) {
  const source = row && typeof row === 'object' ? cloneUpdValue(row) : {}
  const uuid = source.uuid || uuidFactory()
  return {
    ...createEmptyUpdRow(index + 1, uuid),
    ...source,
    id: index + 1,
    uuid,
    measure_value: normalizeSelectOption(source.measure_value, updMeasureOptions, updMeasureOptions[0]),
    nds: normalizeSelectOption(source.nds, updNdsOptions, updNdsOptions[0]),
    warehouse_id: source.warehouse_id || (source.warehouse && source.warehouse.id) || null,
    nomenclature_id: source.nomenclature_id || (source.nomenclature && source.nomenclature.id) || null
  }
}

export function createUpdDocumentForm({ uuidFactory, documentDate = '', inOrgNumber = '' } = {}) {
  const makeUuid = uuidFactory || (() => `upd-row-${Date.now()}`)
  return {
    ...cloneUpdValue(UPD_BODY_DEFAULTS),
    document_date: documentDate,
    in_org_number: inOrgNumber,
    table_rows: [normalizeUpdRow({}, 0, makeUuid)]
  }
}

export function normalizeUpdDocumentBody(body = {}, { uuidFactory } = {}) {
  const source = body && typeof body === 'object' ? cloneUpdValue(body) : {}
  const signatory = source.signatory && typeof source.signatory === 'object' && !Array.isArray(source.signatory)
    ? source.signatory
    : {}
  const makeUuid = uuidFactory || ((index) => `upd-row-${index + 1}`)
  const rows = Array.isArray(source.table_rows) && source.table_rows.length
    ? source.table_rows
    : [{}]
  const normalizedRows = rows.map((row, index) => normalizeUpdRow(row, index, () => makeUuid(index)))
  return {
    ...cloneUpdValue(UPD_BODY_DEFAULTS),
    ...source,
    summary: {
      ...calculateUpdSummary(normalizedRows),
      ...(source.summary && typeof source.summary === 'object' ? source.summary : {})
    },
    document_direction: source.document_direction || source.direction || 'out',
    status: source.status === 2 || String(source.status) === '2' ? 2 : 1,
    signatory: { fio: '', position: '', ...signatory },
    table_rows: normalizedRows
  }
}

export function updVatOptionsForRows(rows = []) {
  const options = updNdsOptions.map((option) => ({ ...option }))
  const labels = new Set(options.map((option) => String(option.label)))
  rows.forEach((row) => {
    const option = normalizeSelectOption(row && row.nds, [], null)
    if (option && option.label && !labels.has(String(option.label))) {
      labels.add(String(option.label))
      options.push(option)
    }
  })
  return options
}

export function buildUpdEditableBody(form, documentDate) {
  const source = cloneUpdValue(form || {})
  const signatory = source.signatory && typeof source.signatory === 'object' && !Array.isArray(source.signatory)
    ? source.signatory
    : {}
  const isService = Boolean(source.is_service)
  const rows = (source.table_rows || []).map((row, index) => {
    const calculated = calculateUpdRow({ ...cloneUpdValue(row), id: index + 1 }, isService)
    delete calculated.uuid
    Object.assign(calculated, updMeasurePayload(row))
    if (isService) {
      calculated.count = calculated.count || 1
      calculated.warehouse_id = null
      calculated.warehouse = null
      calculated.nomenclature_id = null
      calculated.nomenclature = null
    }
    return calculated
  })
  return {
    ...source,
    signatory: {
      ...signatory,
      fio: source.signatory_type === 'ip' && typeof signatory.fio !== 'object'
        ? (source.ip_name || signatory.fio || '')
        : (signatory.fio || source.rukvod || '')
    },
    summary: {
      ...(source.summary && typeof source.summary === 'object' ? source.summary : {}),
      ...calculateUpdSummary(rows)
    },
    table_rows: rows,
    document_date: documentDate || source.document_date,
    document_type: 'upd',
    report_type: source.report_type || 'none'
  }
}

export function updFormSnapshot(form) {
  const source = cloneUpdValue(form || {})
  ;(source.table_rows || []).forEach((row) => delete row.uuid)
  return JSON.stringify(source)
}

export function normalizeUpdDiagnostics(response = {}) {
  const details = response.details || (response.data && response.data.details) || {}
  const diagnostics = response.diagnostics || details.diagnostics || (response.data && response.data.diagnostics) || []
  return Array.isArray(diagnostics)
    ? diagnostics.map((item, index) => ({
      code: item.code || 'validation_error',
      message: item.message || response.message || 'Проверьте реквизиты документа',
      field_path: item.field_path || item.path || 'document',
      line_index: Number.isInteger(item.line_index) ? item.line_index : null,
      expected: item.expected,
      actual: item.actual,
      source_reference: item.source_reference || item.legal_reference || '',
      key: `${item.field_path || item.path || 'document'}-${index}`
    }))
    : []
}
